import favicon from "assets/images/favicon.png";
//import share from "https://yard.aco-tokyo.com/src/assets/images/ogp.png";

const title = "Yard　一息つけるデザインコミュニティ";
const description =
  "YardはDiscordを使用した誰でも気軽に参加できるオンライン型のデザインコミュニティです。デザイナーの方はもちろん、デザインに興味のある方や学生の方など誰でも参加できます。さまざまな思いを持ったみなさんの心の拠り所の一つとなる場所を作りたいと思い、Yard デザインコミュニティを立ち上げました。";
const share = "https://yard.aco-tokyo.com/static/ogp-194b381a8c2ae839fa51a4727ec80d32.png";
export const helmet = {
  title,
  titleTemplate: "%s by A.C.O. Inc.",
  htmlAttributes: { lang: "jp" },
  meta: [
    { name: "description", content: description },
    {
      name: "viewport",
      content: "width=device-width, initial-scale=1, user-scalable=no",
    },
    { name: "apple-mobile-web-app-status-bar-style", content: "black" },
    { name: "msapplication-navbutton-color", content: "#000" },
    { name: "msapplication-TileColor", content: "#000" },
    { name: "theme-color", content: "#000" },

    { property: "og:title", content: title },
    { property: "og:image", content: share },
    { property: "og:image:width", content: "1200px" },
    { property: "og:image:height", content: "630px" },
    { property: "og:image:alt", content: description },

    { name: "twitter:title", content: title },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:image", content: share },
    { name: 'twitter:site', content: '@aco_tokyo' },
    { name: 'twitter:creator', content: '@aco_tokyo' },
    { name: "twitter:description", content: description },
  ],
  link: [{ rel: "icon", type: "image/x-icon", href: favicon }],
};

